import React from "react";
import Modal from "react-bootstrap/Modal";

const PublishFaqModal = ({ show, onHide, onConfirm, currentFaq }) => {
    const isPublished = currentFaq?.status === "Publish";
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body style={{ padding: "24px", borderRadius: "24px", textAlign: 'center' }}>
                <h3 style={{ marginBottom: '16px' }}>
                    {isPublished ? 'Unpublish FAQ' : 'Publish FAQ'}
                </h3>
                <p style={{ color: '#6B7280', marginBottom: '24px' }}>
                    Are you sure you want to {isPublished ? 'unpublish' : 'publish'} this FAQ?
                </p>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={onHide} style={{ flex: 1, padding: '12px', border: '1px solid #9CA3AF', borderRadius: '27px', background: 'white', color: '#9CA3AF', cursor: 'pointer' }}>
                        Cancel
                    </button>
                    <button onClick={onConfirm} style={{ flex: 1, padding: '12px', background: '#23b4c3', borderRadius: '27px', color: 'white', border: 'none', cursor: 'pointer' }}>
                        Confirm
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PublishFaqModal;
